import ky, { type Options } from 'ky';

import { errorCodeMap } from './errorCodeMap';

// This client is for data fetching from client

const opts: Options = {
  prefixUrl: `${process.env.NEXT_PUBLIC_AUTH_BASE_API_URL}/`,
  timeout: 15000,
  hooks: {
    beforeError: [
      async (error) => {
        // Log errors in development
        if (process.env.DEBUG) {
          console.error(`Error ${error.response.status} for ${error.request.method} "${error.request.url}"`);
          try {
            // Clone the response so body can be read safely
            const clonedResponse = error.response.clone();
            const body = await clonedResponse.json();
            console.error('Received: ', body);
          } catch (_e) {
            // Nothing to do
          }
        }
        return error;
      },
      async (error) => {
        const { response } = error;
        // Try to parse the response body to return the error message from the server
        if (response?.body) {
          try {
            const body: any = await response.json();
            if ('message' in body && typeof body.message === 'string' && body.message.length) {
              error.message = body.message;
            }
            if ('code' in body) {
              // Handle error code mapping
              const errorCode = `${body.code}`;
              if (errorCodeMap.has(errorCode)) {
                error.message = errorCodeMap.get(errorCode)!;
              }
            }
            if ('error_message' in body && typeof body.error_message === 'string' && body.error_message.length) {
              error.message = body.error_message;
            }
            if ('error_code' in body) {
              // Handle error code mapping
              const errorCode = `${body.error_code}`;
              if (errorCodeMap.has(errorCode)) {
                error.message = errorCodeMap.get(errorCode)!;
              }
            }
          } catch (_e) {
            // Nothing to do
          }
        }
        return error;
      },
    ],
  },
};

/**
 * Note: only to be used in server components
 */
export const carmaCsrClient = ky.create({
  ...opts,
  headers: {
    'Content-Type': 'application/json',
  },
});
